import { Page } from 'codegen/schema'
import { Layout } from 'components/layout'
import { RichTextContent } from 'components/rich-text-content'
import { useLoadSettings } from 'hooks/database/use-load-settings'
import { pageQuery } from 'lib/queries'
import { getClient } from 'lib/sanity.server'
import { GetStaticProps } from 'next'
import { groq } from 'next-sanity'

import { urlWithSiteOrigin } from '../../utils/url-with-site-origin'

export interface KnowledgePageProps {
  data: { page: Page; query: string; queryParams: string }
}

export const Knowledge = ({ data: { page } }: KnowledgePageProps) => {
  useLoadSettings()
  const { title, metaDescription, body } = page

  return (
    <Layout
      seoProps={{
        title,
        description: metaDescription,
        canonicalUrl: urlWithSiteOrigin('/knowledge/'),
        pageUrl: urlWithSiteOrigin('/knowledge/'),
      }}
    >
      <RichTextContent body={body} />
    </Layout>
  )
}

/**
 * Fetch the data from Sanity based on the slug
 */
export const getStaticProps: GetStaticProps = async ({ preview = false }) => {
  const query = groq`${pageQuery}`
  const queryParams = { slug: 'knowledge' }
  const pageData = await getClient(preview).fetch(pageQuery, queryParams)
  const page = pageData?.[0]

  // Escape hatch, if our query failed to return page
  if (!page) return { notFound: true }

  return {
    props: {
      // Pass down the "preview mode" boolean to the client-side
      preview,
      // Pass down the initial content, and our query
      data: { page, query, queryParams },
    },
  }
}
